import { render, staticRenderFns } from "./UsageDensity.vue?vue&type=template&id=65daa8a0&"
import script from "./UsageDensity.vue?vue&type=script&lang=js&"
export * from "./UsageDensity.vue?vue&type=script&lang=js&"
import style0 from "./UsageDensity.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports